/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LinkedInMessageTaskCreateMessageDoc } from './linkedInMessageTaskCreateMessageDoc';
import type { LinkedInMessageTaskCreatePriority } from './linkedInMessageTaskCreatePriority';
import type { LinkedInMessageTaskCreateTaskNoteDoc } from './linkedInMessageTaskCreateTaskNoteDoc';

export interface LinkedInMessageTaskCreate {
  job_id: string;
  candidate_id: string;
  assignee_user_id: string;
  due_at?: string | null;
  priority?: LinkedInMessageTaskCreatePriority;
  title?: string | null;
  type: 'linkedin_message';
  linkedin_account_id?: string | null;
  target_linkedin_url?: string | null;
  message_doc: LinkedInMessageTaskCreateMessageDoc;
  include_signature?: boolean;
  task_note_doc?: LinkedInMessageTaskCreateTaskNoteDoc;
}
